export default __webpack_public_path__ + "static/media/vu.853776bf.png";